import {
  GOLD_300,
  MOON_450,
  SIENNA_500,
} from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 8px;
  border: 1px solid var(--moon-moon-250, #dadee3);
  background: var(--moon-white, #fff);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
export const Header = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 32px;
  color: var(--moon-600, #3f4b54);
  margin-bottom: 8px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: ${MOON_450};
`;

export const varSpan = styled.span`
  color: ${SIENNA_500};
`;
export const IconContainer = styled.div`
  background: ${GOLD_300};
  border-radius: 50%;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.66;
`;
export const CodeAltIcon = styled(Icon).attrs({name: 'code-alt'})`
  height: 24px;
  width: 24px;
`;
